import React from 'react';

function About() {
  return (
    <div className="max-w-lg mx-auto mt-8">
      <h1 className="text-2xl mb-4">About</h1>
      <p>This is a wedding guest list manager application built with React, Tailwind CSS, and Firebase.</p>
    </div>
  );
}

export default About;




